import React, { Component } from 'react';
import { GeckoLabel } from 'ui';
import './status.scss';
import { GeckoStatusModel } from '../../models';

class GeckoStatus extends Component {
  render() {
    return <GeckoLabel name={this.props.name} type={this.props.type} />;
  }
}

GeckoStatus.propTypes = GeckoStatusModel;

export default GeckoStatus;
